import {Component, Input} from '@angular/core';
import {AbstractControl, FormControl} from '@angular/forms';

@Component({
  selector: 'app-input-regular',
  templateUrl: './input-regular.component.html',
  styleUrls: ['./input-regular.component.scss']
})
export class InputRegularComponent {

  // controlForm and not formControl because formControl is already an angular attribute.
  @Input()
  controlForm: AbstractControl | FormControl = new FormControl();

  @Input()
  displayErrorDynamic: boolean | undefined;

  @Input()
  label: string = '';

  @Input()
  typeInput: string = '';

  @Input()
  autocomplete: string = '';

  @Input()
  typeLabel: string = 'float';

  @Input()
  placeHolder: string = '';

  constructor() {
  }

  checkEmptyInput(inputField: { value: any; }) {
    return inputField.value;
  }

}
